import { render, staticRenderFns } from "./CidadesTodos.vue?vue&type=template&id=bcb03c34"
import script from "./CidadesTodos.vue?vue&type=script&lang=js"
export * from "./CidadesTodos.vue?vue&type=script&lang=js"
import style0 from "./CidadesTodos.vue?vue&type=style&index=0&id=bcb03c34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports